import { OhsUser } from 'user/OhsUser';
import { ModuleUrl, ModuleRoute } from 'global-services/constants/OhsRoutes';

const createRoute = (path: string, permission: (user: OhsUser) => boolean) => ({
  path,
  url: `/${ModuleUrl.Wmm}/${path}`,
  permission,
});

const OhsWmmSysFieldsRouteList = {
  [ModuleRoute.Home]: createRoute(
    'sys-fields/home',
    (user) => user?.configs.admin2?.PERMISSIONS.view_sysfield || false
  ),
  [ModuleRoute.Details]: createRoute(
    'sys-fields/:id/view',
    (user) => user?.configs.admin2?.PERMISSIONS.view_sysfield || false
  ),
  [ModuleRoute.Add]: createRoute(
    'sys-fields/add',
    (user) => user?.configs.admin2?.PERMISSIONS.create_sysfield || false
  ),
  [ModuleRoute.Edit]: createRoute(
    'sys-fields/:id/edit',
    (user) => user?.configs.admin2?.PERMISSIONS.edit_sysfield || false
  ),
};

export default OhsWmmSysFieldsRouteList;
